import React from "react";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import loginIllustration from "../../Assets/login.png";
import icon from "../../Assets/icon_white.png";
import { translation } from "../../i18n/translationConstant";
import "./index.css";

const HomePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="homePageRoot">
      {/* Background decorative shapes */}
      <div className="homePageDecor homePageDecorTop" />
      <div className="homePageDecor homePageDecorBottom" />

      {/* Brand */}
      <div className="loginBrandBlock">
        <img
          className="loginBrandLogo"
          src={icon}
          alt="INK Account Aggregator"
        />

        <Typography.Text className="loginBrandTagline">
          One Consent. A Smarter You.
        </Typography.Text>
      </div>

      {/* Main message */}
      <div className="loginWelcomeContent">
        <Typography.Title level={1} className="loginWelcomeTitle">
          Welcome back
          <br />
          to Ink
        </Typography.Title>

        <Typography.Paragraph className="loginWelcomeDescription">
          Securely access your account
          <br />
          and manage your financial data
          <br />
          with trusted institutions.
        </Typography.Paragraph>
      </div>

      {/* Illustration */}
      <div className="loginIllustrationWrapper">
        <img
          src={loginIllustration}
          className="loginIllustration"
          alt="Securely manage your financial data with INK-AA"
        />
      </div>

      {/* Trust points */}
      <div className="loginTrustSection">
        <div className="loginTrustItem">
          <div className="loginTrustIcon">✓</div>

          <Typography.Text className="loginTrustTitle">
            Your Data
            <br />
            Your Control
          </Typography.Text>
        </div>

        <div className="loginTrustDivider" />

        <div className="loginTrustItem">
          <div className="loginTrustIcon">⌂</div>

          <Typography.Text className="loginTrustTitle">
            Secure
            <br />
            & RBI Regulated
          </Typography.Text>
        </div>

        <div className="loginTrustDivider" />

        <div className="loginTrustItem">
          <div className="loginTrustIcon">▤</div>

          <Typography.Text className="loginTrustTitle">
            Transparency
            <br />
            at Every Step
          </Typography.Text>
        </div>
      </div>
    </div>
  );
};

export default HomePage;